
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { getBrandRole } from "../../../services/StoreUsers/PostStoreUsers";

const RoleFilterModal = ({
  roleFilterModalVisible,
  setRoleFilterModalVisible,
  sendDataToRoleFromFilter,
  brandId,
  isWareHouseModel,
}) => {
  
  const [roleItems, setRoleItems] = useState([]);

  const fetchBrandRole = () => {
    getBrandRole(brandId)
      .then(response => {
        if (!response.data.error) {
          const role = isWareHouseModel
            ? response.data
            : response.data.filter(item => item.role !== 'ROLE_WAREHOUSE');

          setRoleItems(role);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    fetchBrandRole();
  }, []);

  const [selectedStatus, setSelectedStatus] = useState([]);

  const handleStatusToggle = status => {
    const updatedStatus = [...selectedStatus];

    if (updatedStatus.includes(status)) {
      // Remove status if already selected
      updatedStatus.splice(updatedStatus.indexOf(status), 1);
    } else {
      // Add status if not selected
      updatedStatus.push(status);
    }

    setSelectedStatus(updatedStatus);
  };
  const handleConfirmPickup = () => {
    // Close the modal
    setRoleFilterModalVisible(false);
    sendDataToRoleFromFilter(
      selectedStatus.length > 0
        ? selectedStatus
        : roleItems.map(item => item.role),
    );
  };

  const handleModalClose = () => {
    setRoleFilterModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={roleFilterModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!roleFilterModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
              Select Role
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="mx-4">
              {roleItems?.map((item) => (
                <div key={item.id} className="flex flex-1 justify-content-between my-1">
                  <p className="text-xl font-medium">{item.role.replace(/_/g, ' ')}</p>
                  <div>
                    <Checkbox
                      checked={selectedStatus.includes(item.role)}
                      size="20" // Increased size
                      color={
                        selectedStatus.includes(item.role)
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() => handleStatusToggle(item.role)}
                    />
                  </div>
                </div>
              ))}
            </div>
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Filter
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default RoleFilterModal;